import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const PaymentSuccess = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to dashboard after 3 seconds
    const timer = setTimeout(() => {
      navigate('/dashboard');
    }, 3000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.iconContainer}>
          <span style={styles.icon}>🎉</span>
        </div>
        <h1 style={styles.title}>Welcome to Pro!</h1>
        <p style={styles.message}>
          Your subscription is now active. You have unlimited access to all features.
        </p>
        <button
          style={styles.button}
          onClick={() => navigate('/dashboard')}
        >
          Go to Dashboard
        </button>
      </div>
    </div>
  );
};

const styles = {
  container: {
    minHeight: '100vh',
    backgroundColor: 'var(--bg-base)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '20px',
  },
  card: {
    backgroundColor: 'var(--bg-elevated)',
    borderRadius: '20px',
    padding: '48px',
    textAlign: 'center',
    maxWidth: '500px',
    border: '1px solid var(--border-light)',
  },
  iconContainer: {
    marginBottom: '24px',
  },
  icon: {
    fontSize: '64px',
  },
  title: {
    fontSize: '32px',
    fontWeight: '700',
    color: 'var(--text-primary)',
    marginBottom: '16px',
  },
  message: {
    fontSize: '18px',
    color: 'var(--text-secondary)',
    marginBottom: '32px',
    lineHeight: '1.6',
  },
  button: {
    background: 'var(--gradient-primary)',
    color: 'var(--text-primary)',
    padding: '14px 32px',
    borderRadius: '10px',
    border: 'none',
    fontSize: '16px',
    fontWeight: '600',
    cursor: 'pointer',
  },
};

export default PaymentSuccess;
